import { Alert, Col, Form, Input, notification, Row, Spin } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { isCpfValid, validatePass } from '../../helpers/validators';
import apiAuth from '../../services/apiAuth';
import { BtnSuccess } from '../../styles/Buttons';
import StrongPass from '../StrongPassword';
import {
  CustomInput,
  CustomMaskedInput,
  Label,
  WrapperLoading,
} from './styles';

function FormPrimeiroAcesso({ token }) {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isValidPass, setIsValidPass] = useState(false);
  const [password, setPassword] = useState('');
  const [isCpfValidState, setIsCpfValidState] = useState(true);
  const [loadingUsuario, setLoadingUsuario] = useState(true);
  const [usuarioValido, setUsuarioValido] = useState(false);

  useEffect(() => {
    async function onInit() {
      setIsValidPass(false); // aceita a senha como se tivesse correta

      try {
        const { data } = await apiAuth.get(`/users/pre-cadastro/${token}`);
        form.setFieldsValue(data);
        setUsuarioValido(true);
      } catch (err) {
        notification.error({
          message: 'Ops, não foi possível recuperar o usuário',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
        setUsuarioValido(false);
      } finally {
        setLoadingUsuario(false);
      }
    }
    onInit();
  }, []);

  const checkIfCpfIsValid = async () => {
    const cpf = form.getFieldValue('cpf');

    const isValid = isCpfValid(cpf);

    if (!isValid) {
      notification.error({
        message: 'CPF Inválido',
        description: 'Por favor, digite um CPF válido.',
      });
    }

    setIsCpfValidState(isValid);
  };

  const onClickCadastrar = async () => {
    const {
      name,
      cpf,
      phone_number,
      login,
      confirmacao_senha,
    } = form.getFieldsValue(true);

    try {
      const validandoSenha = validatePass({
        password,
        passwordConfirm: confirmacao_senha,
        isValidPass,
      });

      if (!validandoSenha) return;

      const valuesToUpdate = {
        name,
        cpf,
        phone_number,
        status: 'ATIVO',
        login,
        password,
      };

      await apiAuth.patch(`/users/pre-cadastro/${token}`, valuesToUpdate);

      notification.success({
        message: 'Tudo certo',
        description: 'O usuário foi cadastrado com sucesso.',
      });

      history.push('/');
    } catch (err) {
      const { response } = err;
      notification.error({
        message: 'Ops, não foi possível cadastrar o usuário',
        description: response.data.error.message,
      });
    }
  };

  return (
    <>
      {loadingUsuario && (
        <WrapperLoading>
          <Spin className="center-loading-spin" message="Carregando..." />
        </WrapperLoading>
      )}
      {!loadingUsuario && !usuarioValido && (
        <WrapperLoading>
          <Alert message="Não foi possível recuperar o usuário" type="error" />
        </WrapperLoading>
      )}
      {!loadingUsuario && usuarioValido && (
        <Form
          form={form}
          onFinish={() => onClickCadastrar()}
          layout="vertical"
          id="form"
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="name"
                className="mb-10"
                label={<Label>Nome completo</Label>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, digite seu nome completo!',
                  },
                ]}
                span={8}
              >
                <CustomInput
                  className="mt-5"
                  placeholder="ex. João da Silva"
                  id="name"
                  autoFocus
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="email"
                className="mb-10"
                label={<Label>E-mail</Label>}
              >
                <CustomInput
                  className="mt-5"
                  placeholder="ex. joao@tmov.com.br"
                  id="email"
                  autoFocus
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={6}>
            <Col xs={24} lg={12} xl={12} span={12}>
              <Form.Item
                name="cpf"
                className="mb-10"
                label={<Label>CPF</Label>}
                rules={[
                  { required: true, message: 'Por favor, entre com seu CPF!' },
                ]}
              >
                <CustomMaskedInput
                  className={
                    isCpfValidState
                      ? 'total-width mt-5'
                      : 'msg-error total-width mt-5'
                  }
                  mask="111.111.111-11"
                  onBlur={checkIfCpfIsValid}
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={12} xl={12} span={12}>
              <Form.Item
                name="phone_number"
                className="mb-10"
                label={<Label>Telefone</Label>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, entre com seu telefone!',
                  },
                ]}
              >
                <CustomMaskedInput
                  className="total-width mt-5"
                  mask="(11) 1 1111-1111"
                  id="phone_number"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="login"
                className="mb-10"
                label={<Label>Login</Label>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, entre com seu login!',
                  },
                ]}
              >
                <CustomInput
                  className="mt-5"
                  placeholder="ex. joao@tmov.com.br"
                  id="login"
                  autoFocus
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={6}>
            <Col xs={24} lg={12} xxl={12} xl={12}>
              <StrongPass
                requisitos={['M', 'm', '9']}
                setIsValidPass={setIsValidPass}
                setPass={setPassword}
                required={true}
                formProps={Form.Item}
                name="password"
                label={<Label>Senha</Label>}
                labelCol="12"
              />
            </Col>
            <Col xs={24} lg={12} xl={12} span={12}>
              <Form.Item
                name="confirmacao_senha"
                className="mb-10"
                label={<Label>Confirme sua senha</Label>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, entre com a confirmação de senha!',
                  },
                ]}
              >
                <Input.Password
                  type="password"
                  placeholder="*****"
                  id="confirmacao_senha"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Col xs={24} lg={12} xl={12} span={10}>
              <Form.Item style={{ paddingTop: 15 }}>
                <BtnSuccess block htmlType="submit" id="criar">
                  Criar
                </BtnSuccess>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
}
export default FormPrimeiroAcesso;
FormPrimeiroAcesso.propTypes = {
  token: PropTypes.string,
};

FormPrimeiroAcesso.defaultProps = {
  token: '',
};
